let polyfillInjected = false;

export const injectSmoothScrollPolyfill = async () => {
  if ("scrollBehavior" in document.documentElement.style) {
    return;
  }

  if (polyfillInjected) {
    return;
  }

  try {
    const { polyfill } = await import("smoothscroll-polyfill");
    polyfill();
    polyfillInjected = true;
  } catch {
    /* eslint-disable-next-line no-console */
    console.log("[windowUtils#injectSmoothScrollPolyfill]");
  }
};

export const WindowSizes = {
  LG: "LG",
  MD: "MD",
  SM: "SM",
  XS: "XS",
};

export const ClientWindowSizes = {
  LG: 1280,
  MD: 992,
  SM: 576,
  XS: 320,
};

export const getClientWindowSize = (windowWidth) => {
  return Object.keys(ClientWindowSizes).find((key) => {
    const ruleSize = ClientWindowSizes[key];
    return windowWidth >= ruleSize;
  });
};
